export default [
    {
        path: '/sample',
        name: 'Sample',
        component: () => import('@/views/sample'),
        meta:
        {
            name: 'Sample',

            page: 'list',
        },
        children:
        [
            {
                path: 'create',
                name: 'Create Sample',
                component: () => import('@/views/sample'),
                meta:
                {
                    page: 'create',
                    subPage: 'main',
                    name: 'Create Sample',
                },
            },
            {
                path: ':code',
                name: 'View Sample',
                component: () => import('@/views/sample'),
                meta:
                {
                    page: 'view',
                    name: 'View Sample',
                },
                children:
                [
                    {
                        path: 'edit',
                        name: 'Edit Sample',
                        component: () => import('@/views/sample'),
                        meta:
                        {
                            page: 'edit',
                            subPage: 'main',
                        },
                    },
                ],
            },
        ],
    },
];